export const totalsState = {
  activeUsers: 0,
  inactiveUsers: 0,
  lastUpdatedDateTime: "",
  usersWithFever: 0,
};
